import { DEFAULT_MULTIROOM_AVAILABILITY, DEFAULT_MULTIROOM_GUESTS } from '../constants';
import { HotelsConfig } from '../types';

const getMultiroomParamsByConfig = (hotelsConfig?: HotelsConfig) => {
  return {
    hasMultiroom: hotelsConfig?.multiroom?.active ?? DEFAULT_MULTIROOM_AVAILABILITY,
    maxGuestsCount: hotelsConfig?.multiroom?.guests ?? DEFAULT_MULTIROOM_GUESTS,
  };
};

export default getMultiroomParamsByConfig;
